import {Box, Title} from '@mantine/core';
import Head from 'next/head';
import {useRouter} from 'next/router';
import type {FC} from 'react';
import {MdHome} from 'react-icons/md';
import {COLOR_LINK_1} from '../../../config/constants/colorCodes';
import {GSSKT_HOST} from '../../../config/constants/hosts';
import {
  ClipConstants,
  ClipType,
  PAGE_MYPAGE,
} from '../../../core/entities/clip/constants';
import {SectionTitle} from '../../../shared/components/SectionTitle';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';
import {
  ClipListContainer,
  ClipListForMobileContainer,
} from './ClipList/Container';
import {ClipSectionTitle} from './ClipSectionTitle';
import {ClipTabForMobile} from './ClipTab';
import {PageTabForMobile} from './PageTab';

const PcComponent: React.FC = () => {
  return (
    <>
      <SectionTitle order={1} title={`${ClipConstants.MANAGEMENT}`} />
      <Box className="mb-10 relative bg-white p-32 text-lg">
        <ClipSectionTitle title={ClipConstants.REPORTS} />
        <ClipListContainer clipType={ClipType.REPORT} />
      </Box>
    </>
  );
};

const MobileComponent: React.FC = () => {
  const router = useRouter();
  return (
    <section>
      <Box className="min-h-[52px] w-full border-t-2 border-solid border-link bg-white px-16">
        <Title
          order={1}
          className="relative flex items-center text-lg font-[400] leading-[52px] text-black-1"
        >
          <MdHome size="21px" color={COLOR_LINK_1} />
          <span className="ml-8 block">{PAGE_MYPAGE}</span>
        </Title>
      </Box>
      <PageTabForMobile />
      <ClipTabForMobile pathname={router.pathname} />
      <Title order={2} className="mt-12 px-16 text-md font-bold text-black-1">
        {ClipConstants.REPORTS}
      </Title>
      <ClipListForMobileContainer clipType={ClipType.REPORT} />
    </section>
  );
};

export const ReportsPage: FC = () => {
  const router = useRouter();
  const currentUrl = `${GSSKT_HOST}${decodeURI(router.pathname)}`;
  const {isPC} = useMediaQuery();

  const Component = isPC ? PcComponent : MobileComponent;

  return (
    <>
      <Head>
        <title key="title">{`${ClipConstants.REPORTS} | ${ClipConstants.MANAGEMENT}`}</title>
        <meta
          key="og:title"
          property="og:title"
          content={`${ClipConstants.REPORTS} | ${ClipConstants.MANAGEMENT}`}
        />
        <meta key="og:url" property="og:url" content={currentUrl} />
        <meta name="robots" content="noindex" />
      </Head>
      <Component />
    </>
  );
};
